.button {
  font-family: Roboto, sans-serif;
  font-size: 16px;
  cursor: pointer;
  border-radius: 6px;
  display: inline-block;
  color: inherit;
  text-align: center;
}

.button.primary {
  color: var(--tractie-color-content-default-inverse);
  background: var(--tractie-color-background-interactive-default);
  border: none;
  font-weight: 700;
}

.button.primary:hover {
  background: var(--tractie-color-background-interactive-hover);
}

.button.primary:focus {
  color: var(--tractie-color-content-default-inverse);
}

.button.destructive {
  color: var(--tractie-color-content-default-inverse);
  background: var(--tractie-color-background-destructive-default);
  border: none;
  font-weight: 700;
}

.button.destructive-outline {
  color: var(--tractie-color-background-destructive-default);
  background: var(--tractie-color-background-default);
  border: 1px solid var(--tractie-color-background-destructive-default);
  font-weight: 700;
}

.button.destructive-outline:hover {
  background: var(--tractie-color-background-destructive-hover);
  color: var(--tractie-color-content-default-inverse);
}

.button.destructive:hover {
  background: var(--tractie-color-background-destructive-hover);
}

.button.link {
  color: var(--tractie-color-content-interactive-default);
  border: 1px solid transparent;
  background: transparent;
  font-weight: 700;
}

.button.link:hover {
  color: var(--tractie-color-content-interactive-hover);
  background: var(--tractie-color-background-hover);
}

.button.link:focus {
  color: var(--tractie-color-content-interactive-hover);
}

.button.link:active {
  color: var(--tractie-color-content-interactive-pressed);
  background: var(--tractie-color-background-pressed);
}

.button.outline {
  color: var(--tractie-color-content-interactive-default);
  background: transparent;
  border: 1px solid var(--tractie-color-border-interactive-default);
  font-weight: 700;
}

.button.outline:hover {
  border: 1px solid var(--tractie-color-border-interactive-hover);
  color: var(--tractie-color-content-interactive-hover);
  background: var(--tractie-color-background-hover);
}

.button.outline:focus {
  color: var(--tractie-color-content-interactive-hover);
}

.button.outline:active {
  color: var(--tractie-color-content-interactive-pressed);
  background: var(--tractie-color-background-pressed);
  border-color: var(--tractie-color-border-interactive-pressed);
}

.button.chip {
  color: var(--tractie-color-content-emphasis);
  background: transparent;
  border: 1px solid var(--tractie-color-border-emphasis);
  border-radius: 6px;
  font-weight: 500;
  font-size: 14px;
}

.button.chip.sm {
  color: var(--tractie-color-content-emphasis);
  background: transparent;
  border: 1px solid var(--tractie-color-border-emphasis);
  border-radius: 6px;
  font-weight: 500;
  font-size: 14px;
}

.button.chip:hover {
  border: 1px solid var(--tractie-color-border-interactive-hover);
  background: var(--tractie-color-background-hover);
}

.button.disabled {
  background: var(--tractie-color-background-accent-gray-subtle);
  cursor: not-allowed;
}

.button.primary.disabled {
  color: var(--tractie-color-content-default-inverse);
}

.button.destructive.disabled {
  color: var(--tractie-color-content-default-inverse);
}

.button.outline.disabled {
  color: var(--tractie-color-content-interactive-default);
}

.button.chip.disabled {
  border: 1px solid var(--tractie-color-border-default);
  background: var(--tractie-color-content-default);
}

.button.chip.disabled:hover {
  cursor: auto;
  background: var(--tractie-color-content-default);
  border: 1px solid var(--tractie-color-border-default);
}

.button.small {
  padding: 0 0 0 4px;
  height: 26px;
}

.button.medium {
  padding: 0 12px;
  height: 32px;
}

.button.large {
  padding: 4px 16px;
  height: 40px;
}

.button.full {
  width: 100%;
}

.button.auto {
  width: auto;
}
